import type { FaireProductEntity } from "../../entity_types/product";

export const p_y6s9dvyvsd: FaireProductEntity = {
  token: "p_y6s9dvyvsd",
  type: "product",
  name: "Be Well Essential Oil Roller-ball - Assembled by Survivors",
  brandToken: "b_acbb4naqbw",
  brandName: "Crowned Free",
  imageUrl: "https://cdn.faire.com/fastly/d3ba34c917384419acc1bece0c355f87720e51d898b4278b52c1b3fbe301c81c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c062d0a3336cd70acadd420debd2b8584b7ffb3339ec2967c100b8e4d98fe862.jpeg",
    "https://cdn.faire.com/fastly/c624da7d164b433bd054f2cb39b9c1952ba28641a5a114e48ae95ff5012c23c9.png"
  ],
  priceDollars: 13.86,
  description: "Be Well - Release and Relieve\n\n-Made in USA\n-Assembled by survivors and at-risk youth in Michigan\n-Net Wt. 0.34 fl. oz. (10ml)\n\nDirections: Apply directly on your chest, torso, back of neck, shoulders, and bottom of feet.\n\nCaution: For external use only. Keep out of reach of children. Avoid eyes and other sensitive areas. Keep away from direct flame. If pregnant or nursing, consult a physician before using essential oils.\n\nStorage: Store at room temperature and avoid direct sunlight. \n\nOn a mission to end human trafficking through ethical fashion and gifts. At Crowned Free, we are committed to raising awareness, providing safe and sustainable jobs to empower survivors, choosing ethical sourcing for our products, and giving back to anti-trafficking organizations both locally and globally.\n\n\n\n \n\n",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:58.454Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
